module.exports = __webpack_public_path__ + "static/media/15.f21c7766.jpeg";